import gql from 'graphql-tag'
const SPEAKER_QUERY = (variablesForQier) => {
	return gql`
	query(
	${variablesForQier.conferenceSeriesId != "notset" && variablesForQier.instanceId == "" ? `$conferenceSeriesId:String!` : "" },
	${variablesForQier.conferenceSeriesId == "notset" && variablesForQier.instanceId == "" ? `$brandId:String!` : "" },
	${variablesForQier.instanceId != "" ? `$instanceId: [String]!` : "" } 
	$pagesize:Int!,$page:Int!,
	${variablesForQier.qualificationIdIn != "" ? `$qualificationIdIn: [String]!` : "" },
	${variablesForQier.trackFilter != "" ? `$trackFilter: [String]!` : "" }) {
		vueExperts(
			${variablesForQier.conferenceSeriesId != "notset" && variablesForQier.instanceId == "" ? `conferenceSeriesId:$conferenceSeriesId` : "" },
			${variablesForQier.conferenceSeriesId == "notset" && variablesForQier.instanceId == "" ? `conferenceBrandId:$brandId` : "" },
			${variablesForQier.instanceId != "" ? `conferenceIds_in: $instanceId` : "" },
			PAGE_SIZE:$pagesize
			PAGE:$page
			${variablesForQier.qualificationIdIn != "" ? `qualificationIds_in:$qualificationIdIn` : "" }
			${variablesForQier.trackFilter != "" ? `trackIds_in:$trackFilter` : "" }
			SORT:{surname:1}
			) {
			Experts {
				_id
				surname
				forename
				bio
				slug
				__typename
				company
				shortBioEn
				shortDioDe
				summaryEn
				summaryDe
				avatarSquareSmall {
					x
					xx
					xxx
				}
				qualifications{
                        _id
                        name
                    }
			}
		}
	}
	`
}
const SPEAKER_QUERY_BY_BRAND_ID  = gql`
query ($pagesize: Int!, $page: Int!, $conferenceBrandId: String!) {
  vueExperts(
    PAGE_SIZE: $pagesize
    PAGE: $page
	conferenceBrandId: $conferenceBrandId
    SORT: {surname: 1}
  ) {
    Experts {
      _id
      surname
      forename
      bio
      slug
      __typename
      company
      avatarSquareSmall {
        x
        xx
        xxx
        __typename
      }
      qualifications {
        _id
        name
        __typename
      }
    }
    __typename
  }
}
`

const EXPERTS_BY_SLUG_QUERY  = gql`
query($slugs: [String]!){
  experts(slugs:$slugs,origin:SPEAKER){
    Experts{
      _id
      forename
      surname
      company
	  shortBioEn
	  shortDioDe
      bio
      slug
      avatarSquareSmall {
        x
        xx
        xxx
        svg
      }
    }
  }
}
`

const EXPERT_BY_SLUG_QUERY  = gql`
query($slug: String!,$conferenceBrandId:String!){
	vueExpert(slug:$slug,conferenceBrandId:$conferenceBrandId){
    Expert{
		_id
		forename
		surname
		company
		shortBioEn
	    shortDioDe
		bio
		bioEn
		bioDe
		facebook
		twitter
		linkedIn
		blog
    	slug
		avatarSquareSmall {
		x
		xx
		xxx
		svg
		}
		sessions{
			name
			_id
			primaryTrack{
				name
			   slug
		   }
			slugNames
			localizedStartDate
			localizedEndDate
			updatedAt
			type
			eventId
			conferenceIds
		}
    }
  }
}
`


const GET_BRAND_POC_ISSUE = gql `
query ($type: PieceOfContentQueryType!, $brandComplexSlug: String!, $PAGE: Int!, $PAGE_SIZE: Int!) {
  pieceOfContent(type: $type, brandComplexSlug: $brandComplexSlug, PAGE: $PAGE, PAGE_SIZE: $PAGE_SIZE) {
    Meta {
      count
      __typename
    }
    PieceOfContent {
		_id
		slug
		schemaType
  brandName
  sortDate
  isReadContent
  designation
		type
		parentSlug
		parentSchemaType
  		parentGenre
		parentId
		parentColorHexCode
		parentName
		language
		startDate
		endDate
		marketingUrl
  		availableUntilDate
		timezone
		duration
		parentGenre
		parentLogo
		title
		subtitle
		teaserImage
		categoryIds
		categories {
			_id
			name
		}
		language
		expertNames
		expertSlugs
		duration
		categories {
			_id
			name
		}
		expertIds
  experts {
	_id
	name
	slug
	image
  }
		progress {
			total
			completed
			value
		}
	}
    __typename
  }
}
`

const SESSION_BY_SLUG_QUERY = gql`
query ($sessionSlug: [String]!,$brandId:String!) {
	vueSessions(
		slugs_in: $sessionSlug
		conferenceBrandId:$brandId
		SORT: { startDate: 1 }
		) {
		Sessions {
			_id
			name
			slugNames
			sessionType{
				name
				slug
			}
			longAbstract
			localizedStartDate
			conferenceIds
			localizedEndDate
			primaryTrack{
				name
			   slug
		   }
			details
			roomName
			workshopShortLabel
			workshopRequirements
			experts {
				surname
				company
				forename
				slug
				avatarSquareSmall {
					x
					xx
					xxx
					xxxx
					svg
				}
			}
			tracks {
				_id
				name
				slug
			}
		}

		__typename
	}
	__typename
}
`
const SALES_SPONSOR_QUERY = gql`
	query ($conferenceSeriesId: String!) {
		vuePartnerTypes(
		conferenceSeriesId: $conferenceSeriesId 
		SORTS:[{displayNameDe:1},{displayNameEn:1}]
		){
			PartnerTypes {
				_id
				displayNameDe
				displayNameEn
				displayNameInPartnerDe
				order
				displayNameInPartnerEn
				partners{
					information
					websiteUrl
					_id
					logo{x xx xxx xxxx}
					name
				}
			}
			
		}
	}
`

const MARKETING_SPONSOR_QUERY = gql`
	query ($conferenceSeriesId: String!) {
		vueMarketingPartnerTypes(
		conferenceSeriesId: $conferenceSeriesId 
		SORTS:[{displayNameDe:1},{displayNameEn:1}]
		){
			MarketingPartnerTypes {
				_id
				displayNameDe
				displayNameEn
				order
				displayNameInPartnerDe
				displayNameInPartnerEn
				marketingPartners{
					information
					websiteUrl
					_id
					name
					logo{x xx xxx xxxx}
				}
			}
		}
	}
`

const SESSIONS_QUERY = (queryVariables) => {
	return gql`
	query (${queryVariables.instanceId == "" ? `$id: String!` : "" }, $page_size: Int!,${queryVariables.qualificationIdIn != "" ? `$qualificationIdIn: [String]!` : "" }, $page: Int!,${queryVariables.instanceId != "" ? `$instanceId: [String]!` : "" },${queryVariables.typeIn != "" ? `$typeIn: [String]!` : "" },${queryVariables.trackIn != "" ? `$trackIn: [String]!` : "" }) {
		vueSessions( 
			${queryVariables.typeIn != "" ? `type_in: $typeIn` : "" },
			${queryVariables.trackIn != "" ? `trackIds_in: $trackIn` : "" },
			${queryVariables.instanceId != "" ? `conferenceIds_in: $instanceId` : "" },
			${queryVariables.instanceId == "" ? `conferenceSeriesId: $id` : "" },
			${queryVariables.qualificationIdIn != "" ? `qualificationIds_in:$qualificationIdIn` : "" }
			SORTS: [{startDate: 1}, 
				{name: 1}], 
				PAGE: $page, 
				PAGE_SIZE: $page_size
		) {
			Sessions {
				_id
				name
				accessible
				eventId
				localizedStartDate
				localizedEndDate
				timezone
				details
				type
				sessionType {
					_id
					type
					uniqueId
					type
					name
					slug
					colourHexCode
					image {
					  xx
					  xxx
					  xxxx
					  __typename
					}
					__typename
				  }
				timezone
				localizedStartDate
				qualifications{
					_id
					name
					nameDe
					uniqueId
				}
				qualificationIds
				localizedEndDate
				longAbstract
				workshopShortLabel
				roomName
				language
				slugNames
				primaryTrackId
				primaryTrack {
				  name
				  _id
				  slug
				  __typename
				}
				trackIds
				tracks {
				  name
				  _id
				  uniqueId
				  __typename
				  slug
				}
				
				workshopRequirements
				experts {
				  surname
				  _id
				  forename
				  __typename
				  company
				  bio
				  slug
				  avatarSquareSmall {
					x
					xx
					xxx
					xxxx
					__typename
				  }
				}
				pdf {
				  name
				  type
				  url
				  uploadedAt
				  __typename
				}
				__typename
			  }

		__typename
		}
	}
	`
}

const SESSION_BY_TRACK_QUERY = gql`
query (
	$id: [String]!
	$conferenceId: [String]!
) {
	vueSessions(
		trackIds_in: $id
		conferenceIds_in: $conferenceId
		PAGE: 1
		PAGE_SIZE: 3
	) {
		Sessions {
			_id
			name
			slugNames
			primaryTrack {
				name
				_id
				slug
				__typename
			}
			trackIds
			tracks {
				name
				_id
				uniqueId
				__typename
				slug
			}

			__typename
		}
		__typename
	}
}`
const GET_CURRENT_INSTANCE_QUERY = gql`
query ($brandId: String!){
	conferenceBrands(_id:$brandId){
		ConferenceBrands {
			name
			conferenceSeriesItems {
				name
				currentCourse{
					uniqueId
					language
				}
				_id
				uniqueId
				slug
			}
		}
	}
}`

const PROGRAM_FOR_TRACK_PAGE_QUERY = (queryVariables) => {
	return gql`
	query (
		${queryVariables.instanceId == "" ? `$id: String!` : "" },
		${queryVariables.instanceId != "" ? `$instanceId: [String]!` : "" }
		$trackIn: [String]!
		$page:Int!, 
		$pagesize:Int!
	) {
		vueSessions( 
			${queryVariables.instanceId != "" ? `conferenceIds_in: $instanceId` : "" },
			${queryVariables.instanceId == "" ? `conferenceSeriesId: $id` : "" },
			trackIds_in: $trackIn,
			SORTS: [{startDate: 1}, 
				{name: 1}], 
				PAGE: $page, 
				PAGE_SIZE: $pagesize
		) {
			Sessions {
				_id
				name
				accessible
				eventId
				localizedStartDate
				localizedEndDate
				timezone
				slugNames
				details
				type
				sessionType {
					_id
					type
					uniqueId
					type
					name
					slug
					colourHexCode
					image {
					  xx
					  xxx
					  xxxx
					  __typename
					}
					__typename
				  }
				timezone
				localizedStartDate
				qualifications{
					_id
					name
					nameDe
					uniqueId
				}
				qualificationIds
				localizedEndDate
				longAbstract
				workshopShortLabel
				roomName
				language
				primaryTrackId
				primaryTrack {
				  name
				  _id
				  slug
				  __typename
				}
				trackIds
				tracks {
				  name
				  _id
				  uniqueId
				  __typename
				  slug
				}

				workshopRequirements
				experts {
				  surname
				  _id
				  forename
				  __typename
				  company
				  bio
				  slug
				  avatarSquareSmall {
					x
					xx
					xxx
					xxxx
					__typename
				  }
				}
				pdf {
				  name
				  type
				  url
				  uploadedAt
				  __typename
				}
				__typename
			  }

		__typename
		}
	}`}

const SPECIAL_DAYS_QUERY = gql`
	query($id:String!,$conferenceBrandId: String!){
		vueSpecialDays(
			conferenceSeriesId:$id
			conferenceBrandId: $conferenceBrandId
			){
		Meta{
			count
		}
		SpecialDays {
			_id
			name
			conferenceIds
			details
			startDate
			timezone
			endDate
			order
			uniqueId
			localizedStartDate
			localizedEndDate
		}
	}
}
`
const GET_SESSION_QUALIFICATIONS = gql`
	query {
		qualifications(type: SESSION, SORT: { name: 1 }) {
			Qualifications {
				_id
				uniqueId
				name
				nameDe
				nameEn
				type
				updatedAt
				publishedAt
			}
		}
	}
`
const GET_SESSION_BY_QUALIFICATIONS = gql`
	query (
		$id: String!
		$qualificationIds_in: [String]!
	) {
		vueSessions(
			conferenceSeriesId: $id
			qualificationIds_in: $qualificationIds_in
			PAGE: 1
			PAGE_SIZE: 6
		) {
			Sessions {
				_id
				name
				slugNames
				primaryTrack{
				slug
				}
				experts {
					surname
					_id
					forename
					__typename
					company
					bio
					slug
					avatarSquareSmall {
					  x
					  xx
					  xxx
					  xxxx
					  __typename
					}
				  }

				__typename
			}
			__typename
		}
	}
`


const SPECIAL_DAYS_DETAILS_QUERY = gql`
	query ($id:String!,$specialDaysUniqueId: [String!], $conferenceBrandId: String!) {
		vueSessions(
			conferenceSeriesId:$id
			specialDayIds_in: $specialDaysUniqueId
			conferenceBrandId: $conferenceBrandId
			) {
			Sessions {
				_id
				name
				accessible
				eventId
				localizedStartDate
				localizedEndDate
				timezone
				details
				type
				timezone
				localizedEndDate
				longAbstract
				workshopShortLabel
				roomName
				language
				slugNames
				primaryTrackId
				primaryTrack {
					name
					_id
					slug
					__typename
				}
				trackIds
				tracks {
					name
					_id
					uniqueId
					__typename
					slug
				}
				sessionType {
					_id
					type
					uniqueId
					type
					name
					slug
					colourHexCode
					image {
						x
						xx
						xxx
						xxxx
						__typename
					}
					__typename
				}
				workshopRequirements
				experts {
					surname
					_id
					forename
					__typename
					company
					bio
					slug
					avatarSquareSmall {
						x
						xx
						xxx
						xxxx
						__typename
					}
				}
				localizedStartDate
				sessionType {
					name
				}
				specialDayIds
				specialDays {
					_id
					details
					startDate
					conferenceIds
				}
			}
		}
	}
`
const SPECIAL_DAYS_DISPLAY_QUERY = gql`
	query($conferenceBrandId: String!){
		vueSpecialDays(
			conferenceBrandId: $conferenceBrandId
			){
		Meta{
			count
		}
		SpecialDays {
			_id
			name
			conferenceIds
			details
			timezone
			startDate
			endDate
			order
			uniqueId
			localizedStartDate
			localizedEndDate
		}
	}
}
`

export default {
    SPEAKER_QUERY:SPEAKER_QUERY,
	SESSIONS_QUERY:SESSIONS_QUERY,
	SALES_SPONSOR_QUERY:SALES_SPONSOR_QUERY,
	MARKETING_SPONSOR_QUERY:MARKETING_SPONSOR_QUERY,
	SESSION_BY_SLUG_QUERY:SESSION_BY_SLUG_QUERY,
	SESSION_BY_TRACK_QUERY:SESSION_BY_TRACK_QUERY,
	EXPERTS_BY_SLUG_QUERY: EXPERTS_BY_SLUG_QUERY,
	PROGRAM_FOR_TRACK_PAGE_QUERY: PROGRAM_FOR_TRACK_PAGE_QUERY,
	EXPERT_BY_SLUG_QUERY:EXPERT_BY_SLUG_QUERY,
	GET_CURRENT_INSTANCE_QUERY:GET_CURRENT_INSTANCE_QUERY,
	SPECIAL_DAYS_QUERY:SPECIAL_DAYS_QUERY,
	GET_SESSION_QUALIFICATIONS:GET_SESSION_QUALIFICATIONS,
	GET_SESSION_BY_QUALIFICATIONS:GET_SESSION_BY_QUALIFICATIONS,
	SPECIAL_DAYS_DETAILS_QUERY:SPECIAL_DAYS_DETAILS_QUERY,
	SPECIAL_DAYS_DISPLAY_QUERY :SPECIAL_DAYS_DISPLAY_QUERY,
	SPEAKER_QUERY_BY_BRAND_ID: SPEAKER_QUERY_BY_BRAND_ID,
	GET_BRAND_POC_ISSUE: GET_BRAND_POC_ISSUE

}




